<template>
  <div class="the-marathon-users" v-loading.fullscreen="loading">
    <el-row type="flex" align="middle">
      <el-col :span="12">
        <h3>Список учасникiв марафону</h3>
      </el-col>
      <el-col :span="12">
        <h4>{{ marathon.title }}</h4>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        class="k-users-list"
        :data="users"
        style="width: 100%"
      >
        <el-table-column
          class="k-users-list__value"
          label="id"
          width="180">
            <template slot-scope="scope">
              {{ scope.row.user._id }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="E-mail">
            <template slot-scope="scope">
              {{ scope.row.user.email }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Телефон">
            <template slot-scope="scope">
              {{ scope.row.phone }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Имя">
            <template slot-scope="scope">
              {{ scope.row.user.name }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Фамилия">
            <template slot-scope="scope">
              {{ scope.row.user.surname }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Клуб">
            <template slot-scope="scope">
              {{ scope.row.club }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Город">
            <template slot-scope="scope">
              {{ scope.row.runnerCity }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Медаль">
            <div class="k-users-list__medal" slot-scope="scope">
              <i v-if="scope.row.needMedal" class="el-icon-circle-check"></i>
            </div>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Адреса доставки">
            <template slot-scope="scope">
              {{ scope.row.shippingAddress }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Дистанція">
            <template slot-scope="scope">
              {{ `${scope.row.category ? scope.row.category + ' км.' : ''}` }}
            </template>
        </el-table-column>

        <el-table-column
          class="k-users-list__value"
          label="Дата народження">
            <template slot-scope="scope">
              {{ formatDate(scope.row.birth) }}
            </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
/**
 * Component: the-marathon-users - Компонент списка участников системного марафона
 *
 * @version 1.0.0
 */

import * as dayjs from 'dayjs';
import { apiGetMarathon } from "@/api";
import { Auth } from "aws-amplify";
import { mapGetters } from "vuex";

export default {
  name: "the-marathon-users",

  data() {
    return {
      marathon: {},
      users: [],
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      user: "user/user",
    }),
  },

  mounted() {
    this.loadMarathon();
  },

  methods: {
    async getToken() {
      const userSession = await Auth.userSession(this.user);
      return userSession.accessToken.jwtToken;
    },

    async loadMarathon() {
      const marathonId = this.$route.query.id;
      this.loading = true;

      if (marathonId) {
        /* eslint-disable */
        const token = await this.getToken();
        const { marathon = {}, users = [] } = await apiGetMarathon(
          token,
          marathonId
        );
        this.marathon = marathon;
        this.users = users;

        console.log(this.users);

        this.loading = false;
        /* eslint-enable */
      }
    },

    formatDate(date) {
      return date ? dayjs(date).format('DD.MM.YYYY') : '';
    },
  },
};
</script>

<style lang="scss">
@import "~@/scss/styles";

.the-marathon-users {
  $this: &;
  padding-bottom: $vp * 2;

  &__title {
    margin-bottom: $vp;
  }
  &__actions {
    text-align: right;
  }
  &__editor {
    min-height: 300px;
    max-height: 50vh;
  }
  &__upload {
    margin-top: $vp;
    margin-bottom: $vp;
    max-width: 500px;
  }
  &__preview-picture {
    max-width: 100%;
  }
}
.k-users-list {

  &__medal {
    color: #67C23A;
    font-size: 20px;
    text-align: center;
  }
}
</style>
